import { ReactElement, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from 'src/sections/workspace/sections/settings/components/atlassian-intelligence/atlassian-intelligence.i18n';
import { ThingsToKnowHeader } from 'src/sections/workspace/sections/settings/components/atlassian-intelligence/atlassian-intelligence.style';
import atlassianIntelligenceUrls from 'src/sections/workspace/sections/settings/components/atlassian-intelligence/urls';

type Props = {
  children?: ReactNode;
};
export const AtlassianIntelligenceThingsToKnow = ({
  children,
}: Props): ReactElement => {
  return (
    <>
      <ThingsToKnowHeader>
        <FormattedMessage
          {...messages.atlassianIntelligenceThingsToKnowHeader}
        />
      </ThingsToKnowHeader>

      <ul>
        <li>
          <FormattedMessage
            {...messages.atlassianIntelligenceThingsToKnowTrustCenter}
            values={{
              trustCenterLink: (
                <a href={atlassianIntelligenceUrls.ui.trustCenter()}>
                  <FormattedMessage
                    {...messages.atlassianIntelligenceThingsToKnowTrustCenterLinkText}
                  />
                </a>
              ),
            }}
          />
        </li>
        <li>
          <FormattedMessage
            {...messages.atlassianIntelligenceThingsToKnowAcceptableUse}
            values={{
              acceptableUsePolicyLink: (
                <a href={atlassianIntelligenceUrls.ui.acceptableUsePolicy()}>
                  <FormattedMessage
                    {...messages.atlassianIntelligenceThingsToKnowAcceptableUseLinkText}
                  />
                </a>
              ),
            }}
          />
        </li>
        <li>
          <FormattedMessage
            {...messages.atlassianIntelligenceThingsToKnowFeaturesVary}
          />
        </li>
        {children}
      </ul>
    </>
  );
};
